import IntlProps from "../../state/helpers/IntlProps"
import {
    getItemQuantities, getMultiChoiceSelection,
} from "../../state/selection/selectionSelectors"
import {
    editSelectedQuantity, selectMultipleChoice,
} from "../../state/selection/selectionActions"
import {connect, ConnectedProps} from "react-redux"
import {defineMessages, FormattedMessage, injectIntl} from "react-intl"
import React from "react"
import {ProposalItemDto} from "../../state/proposal/Proposal"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component"
import Select from "react-select"
import {SelectOption} from "../../state/helpers/SelectOption"

const messages = defineMessages({
    modal_multiple_choice_label: {
        id: "price_list.configure_price_list_modal.multiple_choices",
        defaultMessage: "Multiple choices"
    },
})

type OwnProps = {
    multiChoiceItems: ProposalItemDto[][]
}


const MultiChoiceItemSelectionComponent = (props: Props & IntlProps) => {

    const getItemQuantity = (item: ProposalItemDto): string => {
        const editableItem = props.itemQuantities.find(i => i.itemId === item.id)
        return editableItem ? editableItem.measure : item.measure
    }

    const isSelected = (id: string): boolean => {
        return props.itemSelection.includes(id)
    }

    const getSelected = (items): ProposalItemDto => {
        return items.find(item => isSelected(item.id))
    }

    const getItemOptions = (items): SelectOption => {
        return items.map(item => {
            return {value: item.id, label: item.title}
        })
    }

    return (
        <div className="mb-3 pt-2">
            <h5>
                <FormattedMessage{...messages.modal_multiple_choice_label}/>
            </h5>

            {props.multiChoiceItems.map(items => {
                const selectedItem = getSelected(items)
                return (
                    getSelected(items) ?
                        <div className="form-group form-row border-bottom border-top py-2 mb-0">
                            <div className="col-2">
                                <InputUnitOfMeasure
                                    name="measure"
                                    value={getItemQuantity(selectedItem)}
                                    onChange={measure => {
                                        props.editSelectedQuantity(items.map(item => {return item.id}), measure)
                                    }}
                                    id={"measure"}
                                    disabled={!getSelected(items).isEditableQuantity}
                                />
                            </div>

                            <div className="col-7 align-self-center">
                                <Select
                                    options={getItemOptions(items)}
                                    value={getSelected(items).id}
                                    onChange={choice => {
                                        props.selectMultipleChoice(choice.value, items.map(item => {return item.id}))
                                    }}
                                    clearable={false}>
                                </Select>
                            </div>
                        </div> : ""
                )
            })
            }
        </div>
    )
}


const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        itemQuantities: getItemQuantities(state),
        itemSelection: getMultiChoiceSelection(state),
    }
}
const mapDispatch = {
    editSelectedQuantity,
    selectMultipleChoice,
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(MultiChoiceItemSelectionComponent))


// WEBPACK FOOTER //
// ./src/price-list/components/MultiChoiceItemSelectionComponent.tsx